<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-form @submit.prevent="submit">
          <b-card>
            <div slot="header">
              <strong>{{ $t('messages.coApplicantInformation') }}</strong>
            </div>

            <b-form-group :label="$t('messages.addCoBuyer')">
                <b-form-radio-group
                    v-model="showApplicantForm"
                    :options="options"
                    plain
                    stacked
                    name="plain-stacked"></b-form-radio-group>
            </b-form-group>
            <section v-show="showApplicantForm">
            <b-form-group>
              <label for="applicant.cobuyer_first_name">{{ $t('messages.firstName') }}*</label>
              <b-form-input
                v-validate="'required'"
                v-model="applicant.cobuyer_first_name"
                name="applicant.cobuyer_first_name"
                type="text"
                :state="validateState('applicant.cobuyer_first_name')"
                :data-vv-as="$t('messages.firstName')"
                :placeholder="$t('messages.enterFirstName')"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="applicant.cobuyer_last_name">{{ $t('messages.lastName') }}*</label>
              <b-form-input
                type="text"
                v-validate="'required'"
                :state="validateState('applicant.cobuyer_last_name')"
                name="applicant.cobuyer_last_name"
                :data-vv-as="$t('messages.lastName')"
                v-model="applicant.cobuyer_last_name"
                :placeholder="$t('messages.enterLastName')"></b-form-input>
            </b-form-group>
            <b-form-group :label="`${$t('messages.phoneNumber')}*`" description="ex. (999) 999-9999">
                <masked-input
                  type="input"
                  name="applicant.cobuyer_phone_number"
                  @keyup="phoneTouched = true"
                  :class="'form-control ' + phoneValidationCssClass"
                  v-model="applicant.cobuyer_phone_number"
                  :mask="['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                  :guide="true"
                  :placeholder="$t('messages.enterPhoneNumber')"
                  placeholderChar="#">
                </masked-input>
                <div class="invalid-feedback">{{ $t('messages.mustBeValidPhone') }}</div>
            </b-form-group>
            <b-form-group>
              <label for="applicant.cobuyer_email_address">Email*</label>
              <b-form-input
                type="email"
                v-validate="'required|email'"
                :state="validateState('applicant.cobuyer_email_address')"
                name="applicant.cobuyer_email_address"
                data-vv-as="Email"
                v-model="applicant.cobuyer_email_address"
                :placeholder="$t('messages.enterEmail')"></b-form-input>
            </b-form-group>
          </section>
            <div slot="footer">
              <b-button
                :disabled="!isComplete || veeErrors.any() || submitting "
                type="submit"
                size="md"
                variant="primary">
                <i class="fa fa-dot-circle-o"></i>
                Continue</b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask'
import { mapActions, mapGetters } from 'vuex';
import VueNotifications from 'vue-notifications';

function formatUsPhone(phone) {
    let phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/);
    phone = phone.trim();
    let results = phoneTest.exec(phone);
    if (results !== null && results.length > 8) {
        return "(" + results[3] + ") " + results[4] + "-" + results[5] + (typeof results[8] !== "undefined" ? " x" + results[8] : "");
    }
    else {
         return phone;
    }
}

export default {
  name: 'co-buyer',
  components: {
    MaskedInput,
  },
  beforeMount() {
      const application = this.$store.getters['creditapps/currentCreditApp'];
      if (application && application.id)  {
        this.applicant = Object.assign({}, application);
      }
      this.showApplicantForm = !!this.applicant.cobuyer_first_name;
  },
  data() {
    return {
      submitting: false,
      applicant: {cobuyer_first_name: '', cobuyer_last_name: '', cobuyer_phone_number: '', cobuyer_email_address: ''},
      showApplicantForm: false,
      options: [
          { text: 'No', value: false },
          { text: 'Yes', value: true },
      ],
      phoneTouched: false,
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Success',
      message: 'Successfully saved.'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Oops',
      message: 'There was an error.'
    }
  },
  computed: {
    isComplete() {
      return !this.showApplicantForm || !!(this.applicant.cobuyer_first_name &&
        this.applicant.cobuyer_last_name &&
        this.applicant.cobuyer_phone_number);
    },
    phoneValidationCssClass () {
      if (!this.phoneTouched) {
        return '';
      }
      const re = /^\(\d{3}\) \d{3}-\d{4}$/
      return re.test(this.applicant.cobuyer_phone_number) ? 'is-valid' : 'is-invalid';
    }
  },
  methods: {
    ...mapActions({
        patchCreditApp: 'creditapps/patchCreditApp',
    }),
    submit() {
        this.submitting = true;
        this.patchCreditApp(this.applicant).then((res) => {
            this.submitting = false;
            this.$router.push({ name: 'Thanks', params: {clientId: this.$route.params.clientId, leadId: this.$route.params.leadId} });
        }).catch((err) => {
            this.submitting = false;
            this.showErrorMsg();
        });
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      }
      return null
    }
  }
}
</script>
